import { sortMessages } from './sortMessages';

export const getLastTicketMessage = (ticket) =>
	sortMessages(ticket[ticket.type].message).at(-1);
